<template>
  <CoreDialog
    data-qa="appointment-documents-info-modal"
    :value="value"
    :size="isMobile ? 'fullscreen' : 'lg'"
    :title="t('Какие документы брать', options)"
    divider
    @input="$emit('input', $event)"
  >
    <template #prependBtn="{ btnProps }">
      <v-btn
        v-bind="btnProps"
        @click="$emit('input', false)"
      >
        <span class="ui-icon-close-not-a-circle" />
      </v-btn>
    </template>

    <div class="text-subtitle-1 text--text">
      {{ t('Общие для всех', options) }}
    </div>
    <div
      v-for="(stepText, stepIndex) in listTextItems"
      :key="stepIndex"
      class="d-flex align-center py-3"
    >
      <div
        class="primary--text text-body-2 d-flex align-center justify-center rounded-circle bg-primary"
        :style="{
          width: '24px',
          height: '24px',
        }"
      >
        {{ stepIndex + 1 }}
      </div>
      <div class="ml-4 text-body-1 text--text">
        {{ stepText }}
      </div>
    </div>
    <div class="text-subtitle-1 text--text mt-5">
      {{ t('Дополнительные', options) }}
    </div>
    <v-expansion-panels
      class="mt-4"
      multiple
    >
      <v-expansion-panel class="text--text">
        <v-expansion-panel-header
          expand-icon="ui-icon-arrow-down"
        >
          <div class="text-body-1">
            {{ t('Родителю, если фамилии родителя и ребёнка отличаются', options) }}
          </div>
        </v-expansion-panel-header>
        <v-expansion-panel-content>
          <div class="text-body-1">
            {{ t('Нужен документ, подтверждающий изменение фамилии', options) }}
          </div>
          <div class="text-body-2 text-secondary--text">
            {{ t('Например, свидетельство о заключении или расторжении брака', options) }}
          </div>
        </v-expansion-panel-content>
      </v-expansion-panel>
      <v-expansion-panel class="text--text">
        <v-expansion-panel-header expand-icon="ui-icon-arrow-down">
          <div class="text-body-1">
            {{ t('Опекуну или попечителю', options) }}
          </div>
        </v-expansion-panel-header>
        <v-expansion-panel-content>
          <div class="text-body-1">
            {{ t('Нужно постановление суда или органов опеки и попечительства, подтверждающее ваш статус', options) }}
          </div>
        </v-expansion-panel-content>
      </v-expansion-panel>
      <v-expansion-panel class="text--text">
        <v-expansion-panel-header expand-icon="ui-icon-arrow-down">
          <div>
            <div class="text-body-1">
              {{ t('Другому сопровождающему', options) }}
            </div>
            <div class="text-body-2 text-secondary--text">
              {{ t('бабушка, дедушка, тётя, дядя, няня, брат или сестра, друг семьи и прочие', options) }}
            </div>
          </div>
        </v-expansion-panel-header>
        <v-expansion-panel-content>
          <div class="text-body-1">
            {{ t('Нужна нотариальная доверенность на представление интересов ребёнка', options) }}
          </div>
          <BannerInfo
            class="mt-2"
            :inner-atom-indent="0"
          >
            <div class="text-subtitle-1">
              {{ t('Требования к доверенности', options) }}
            </div>
            <div class="text-body-2 mt-2">
              {{ t('В ней должно быть указано, что представитель имеет право:', options) }}
              <ul>
                <li>{{ t('получать любую информацию относительно состояния здоровья ребёнка', options) }}</li>
                <li>{{ t('получать справки, выписки, рецепты и иные документы', options) }}</li>
                <!-- eslint-disable max-len -->
                <li>{{ t('принимать решения по вопросам медицинских обследований и медицинских вмешательств', options) }}</li>
                <li>
                  {{ t('подписывать все виды информированных согласий,', options) }}
                  {{ t('в том числе на медицинские вмешательства и вакцинацию.', options) }}
                </li>
              </ul>
            </div>
          </BannerInfo>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>
  </CoreDialog>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import I18NextVue from 'i18next'
import BannerInfo from 'www/vue_components/common/core/BannerInfo.vue'
import CoreDialog from 'src/core/CoreDialog/CoreDialog.vue'
import { AGE_OF_GETTING_PASSPORT } from 'www/vue_components/common/AppointmentPage/constants'
import useFamilyProfilesStore from 'www/vue_components/common/FamilyProfiles/stores/useFamilyProfilesStore'

const { t, language } = I18NextVue
const options = { ns: language }

defineProps<{
  value: boolean
}>()

const familyProfilesStore = useFamilyProfilesStore()

const isMobile = window.MOBILE_VERSION

const listTextItems = computed(() => [
  `${t('Свидетельство о рождении ребёнка', options)} `,
  familyProfilesStore.patientAge >= AGE_OF_GETTING_PASSPORT ? t('Паспорт ребёнка', options) : null,
  t('Паспорт сопровождающего', options),
].filter(item => item))
</script>
